import request from '@/utils/request'
export function listPage(data) {
    return request({
      url: 'admin/data/matter/list',
      method: 'post',
      data
    })
  }
export function productPricelistPage(data) {
    return request({
      url: 'admin/data/productPrice/list',
      method: 'post',
      data
    })
  }
export function productRawlistPage(data) {
    return request({
      url: 'admin/data/productRaw/list',
      method: 'post',
      data
    })
  }
  // 查询产能情况列表
export function listProductCapacity(data) {
  return request({
    url: 'admin/data/productCapacity/list',
    method: 'post',
    data

  })
}
// 查询销售情况列表
export function listProductSale(data) {
  return request({
    url: 'admin/data/productSale/list',
    method: 'post',
    data
  })
}

// 查询销售情况详细
export function getProductSale(id) {
  return request({
    url: 'admin/data/productSale/' + id,
    method: 'get'
  })
}

// 新增销售情况
export function addProductSale(data) {
  return request({
    url: 'admin/data/productSale',
    method: 'post',
    data: data
  })
}

// 修改销售情况
export function updateProductSale(data) {
  return request({
    url: 'admin/data/productSale',
    method: 'put',
    data: data
  })
}

// 删除销售情况
export function delProductSale(id) {
  return request({
    url: 'admin/data/productSale/' + id,
    method: 'delete'
  })
}
// 查询产能情况详细
export function getProductCapacity(id) {
  return request({
    url: 'admin/data/productCapacity/' + id,
    method: 'get'
  })
}

// 新增产能情况
export function addProductCapacity(data) {
  return request({
    url: 'admin/data/productCapacity',
    method: 'post',
    data: data
  })
}

// 修改产能情况
export function updateProductCapacity(data) {
  return request({
    url: 'admin/data/productCapacity',
    method: 'put',
    data: data
  })
}

// 删除产能情况
export function delProductCapacity(id) {
  return request({
    url: 'admin/data/productCapacity/' + id,
    method: 'delete'
  })
}

  // 查询成品相关原料详细
export function getProductRaw(id) {
  return request({
    url: 'admin/data/productRaw/' + id,
    method: 'get'
  })
}

// 新增成品相关原料
export function addProductRaw(data) {
  return request({
    url: 'admin/data/productRaw',
    method: 'post',
    data: data
  })
}

// 修改成品相关原料
export function updateProductRaw(data) {
  return request({
    url: 'admin/data/productRaw',
    method: 'put',
    data: data
  })
}

// 删除成品相关原料
export function delProductRaw(id) {
  return request({
    url: 'admin/data/productRaw/' + id,
    method: 'delete'
  })
}
export function addProductPrice(data) {
    return request({
      url: 'admin/data/productPrice',
      method: 'post',
      data
    })
  }
export function updateProductPrice(data) {
    return request({
      url: 'admin/data/productPrice',
      method: 'put',
      data
    })
  }
  export function delProductPrice(id) {
    return request({
      url: 'admin/data/productPrice/' + id,
      method: 'delete'
    })
  }
  export function infoProductPrice(id) {
    return request({
      url: 'admin/data/productPrice/' + id,
      method: 'get'
    })
  }
  export function matterList(data) {
    return request({
      url: 'admin/data/material/list',
      method: 'post',
      data
    })
  }
  export function add(data) {
    return request({
      url: 'admin/data/matter/add',
      method: 'post',
      data
    })
  }
  export function edit(data) {
    return request({
      url: 'admin/data/matter/edit',
      method: 'post',
      data
    })
  }
  export function info(data) {
    return request({
      url: 'admin/data/matter/info',
      method: 'post',
      data
    })
  }
  // 删除
export function deleteHandle(data) {
  return request({
    url: 'admin/data/matter/remove',
    method: 'post',
    data
  })
}
// 查询经济运行时月度统计数据列表
export function listOperationMonthlyData(data) {
  return request({
    url: 'admin/data/operationMonthlyData/list',
    method: 'post',
    data
  })
}

// 查询经济运行时月度统计数据详细
export function getOperationMonthlyData(id) {
  return request({
    url: 'admin/data/operationMonthlyData/' + id,
    method: 'get'
  })
}

// 新增经济运行时月度统计数据
export function addOperationMonthlyData(data) {
  return request({
    url: 'admin/data/operationMonthlyData',
    method: 'post',
    data: data
  })
}

// 修改经济运行时月度统计数据
export function updateOperationMonthlyData(data) {
  return request({
    url: 'admin/data/operationMonthlyData',
    method: 'put',
    data: data
  })
}

// 删除经济运行时月度统计数据
export function delOperationMonthlyData(id) {
  return request({
    url: 'admin/data/operationMonthlyData/' + id,
    method: 'delete'
  })
}
// 查询产品价格日度统计数据列表
export function listProductPriceDailyData(data) {
  return request({
    url: 'admin/data/productPriceDailyData/list',
    method: 'post',
    data  })
}

// 查询产品价格日度统计数据详细
export function getProductPriceDailyData(id) {
  return request({
    url: 'admin/data/productPriceDailyData/' + id,
    method: 'get'
  })
}

// 新增产品价格日度统计数据
export function addProductPriceDailyData(data) {
  return request({
    url: 'admin/data/productPriceDailyData',
    method: 'post',
    data: data
  })
}

// 修改产品价格日度统计数据
export function updateProductPriceDailyData(data) {
  return request({
    url: 'admin/data/productPriceDailyData',
    method: 'put',
    data: data
  })
}

// 删除产品价格日度统计数据
export function delProductPriceDailyData(id) {
  return request({
    url: 'admin/data/productPriceDailyData/' + id,
    method: 'delete'
  })
}
// 查询产能月度统计数据列表
export function listProductionMonthlyData(data) {
  return request({
    url: 'admin/data/productionMonthlyData/list',
    method: 'post',
    data  })
}

// 查询产能月度统计数据详细
export function getProductionMonthlyData(id) {
  return request({
    url: 'admin/data/productionMonthlyData/' + id,
    method: 'get'
  })
}

// 新增产能月度统计数据
export function addProductionMonthlyData(data) {
  return request({
    url: 'admin/data/productionMonthlyData',
    method: 'post',
    data: data
  })
}

// 修改产能月度统计数据
export function updateProductionMonthlyData(data) {
  return request({
    url: 'admin/data/productionMonthlyData',
    method: 'put',
    data: data
  })
}

// 删除产能月度统计数据
export function delProductionMonthlyData(id) {
  return request({
    url: 'admin/data/productionMonthlyData/' + id,
    method: 'delete'
  })
}
// 查询产能日度统计数据列表
export function listProductionDailyData(data) {
  return request({
    url: 'admin/data/productionDailyData/list',
    method: 'post',
    data  })
}

// 查询产能日度统计数据详细
export function getProductionDailyData(id) {
  return request({
    url: 'admin/data/productionDailyData/' + id,
    method: 'get'
  })
}

// 新增产能日度统计数据
export function addProductionDailyData(data) {
  return request({
    url: 'admin/data/productionDailyData',
    method: 'post',
    data: data
  })
}

// 修改产能日度统计数据
export function updateProductionDailyData(data) {
  return request({
    url: 'admin/data/productionDailyData',
    method: 'put',
    data: data
  })
}

// 删除产能日度统计数据
export function delProductionDailyData(id) {
  return request({
    url: 'admin/data/productionDailyData/' + id,
    method: 'delete'
  })
}
// 查询产品销售月度统计数据列表
export function listProductSaleMonthlyData(data) {
  return request({
    url: 'admin/data/productSaleMonthlyData/list',
    method: 'post',
data  })
}

// 查询产品销售月度统计数据详细
export function getProductSaleMonthlyData(id) {
  return request({
    url: 'admin/data/productSaleMonthlyData/' + id,
    method: 'get'
  })
}

// 新增产品销售月度统计数据
export function addProductSaleMonthlyData(data) {
  return request({
    url: 'admin/data/productSaleMonthlyData',
    method: 'post',
    data: data
  })
}

// 修改产品销售月度统计数据
export function updateProductSaleMonthlyData(data) {
  return request({
    url: 'admin/data/productSaleMonthlyData',
    method: 'put',
    data: data
  })
}

// 删除产品销售月度统计数据
export function delProductSaleMonthlyData(id) {
  return request({
    url: 'admin/data/productSaleMonthlyData/' + id,
    method: 'delete'
  })
}
